module.exports = __webpack_public_path__ + "img/proximanova-semibold-webfont.a56d1ea8.svg";